<template>
  <transition>
    <div class="rule" v-show="show">
      <!--<div class="tip">-->
                        <!--<div class="tip-title">活动规则</div>-->
        <div class="tip-content">
          <p></p>
          <!--<p>&nbsp;&nbsp;&nbsp;&nbsp;活动时间内单张订单金额满1000元，获得1次抽奖机会。按1000元的倍数递增对应的抽奖次数，订单金额低于1000元 ,不计入抽奖资格。</p>-->
<!--          <p>1. 活动期间(7号零时至16号23时59分59秒)在江药仁翔购货金额每单达4000元(含)以上的单个客户，
            可获得抽奖机会1次，满8000元2次(累计满6000元送一次抽奖)以此类推，多购多得。</p>
            <p>2.活动抽奖时间定于2024年10月18日上午10时18分开始。将通过线上平台当众开奖，中奖结果同步在线上平台公示。</p>-->
        </div>
      <!--</div>-->
    </div>
  </transition>

</template>

<script>
export default {
  name: "Rule",
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      show: this.visible
    }
  },
  watch: {
    visible(to, from) {
      this.show = to
    }
  },
  mounted() {

  }
}
</script>

<style scoped lang="scss">
.rule {
  width: 100%;
  max-height: 330px;
  background-image: url(/static/luck-draw-activity/background/draw_rule.png);
  background-size: 100% 100%;
  padding: 30px 10px 10px 10px;
  overflow-y: hidden;
  z-index: 10;
}

.tip {
  position: relative;
  margin: 2.5rem auto 0;
  width: 17.5rem;
  /*border: 1px solid #fbc27f;*/
}

.tip-content {
  padding: 1.5625rem 0.625rem;
  font-size: 0.875rem;
  /*color: #ffeb39;*/
  color: #ffffff;
  line-height: 1.5;
  /*background: #f36d56;*/
}

.tip-title {
  position: absolute;
  top: -1rem;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 1rem;
  color: #fccc6e;
  background: rgb(243, 109, 86);
  padding: 0.3125rem 0.625rem;
}

</style>



// WEBPACK FOOTER //
// Rule.vue?0be7bd3c